import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Custom hook to protect routes that require authentication
 * Redirects to login page if user is not authenticated
 */
const useAuthRequired = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      // Redirect to login page if not authenticated
      navigate('/login', {
        replace: true,
        state: { from: window.location.pathname } // Save the intended destination
      });
    }
  }, [navigate]);
};

export default useAuthRequired;
